import copyTextToClipboard from 'copy-text-to-clipboard';
import { getEnv } from '@m2h/common/utils';
import { Toast } from '../base';
import KNB from '../KNB';

const machProEnvMap = {
  test: 'Test',
  prod: 'Prod',
  st: 'Stage',
};

const getSafeWebUrl = (url: string) => {
  const parsedUrl = new URL(url, window.location?.href);
  if (parsedUrl.protocol !== 'http:' && parsedUrl.protocol !== 'https:') {
    throw new Error(`openURL does not support the ${parsedUrl.protocol} protocol`);
  }
  return parsedUrl.href;
};

const module = {
  isOpenPush() {
    console.log('Empty Func isOpenPush');
    return true;
  },
  setStorage: KNB.setStorage,
  getStorage: KNB.getStorage,
  checkGooglePlayServices() {
    // return false;
    return true;
  },
  getInstalledAppList() {
    return [];
  },
  getEnv() {
    const env = getEnv();
    return {
      env: machProEnvMap[env],
    };
  },
  // 文案宽度计算
  widthForText(data) {
    const {
      fontSize, bold, maxWidth, content
    } = data;

    if (!content || typeof content !== 'string') {
      console.warn('文案内容无效');
      return 0;
    }
    // 创建临时 canvas 用于测量文本宽度
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    if (!context) {
      return 0;
    } // 设置字体样式
    context.font = `${bold ? 'bold' : 'normal'} ${fontSize}px Arial`;

    // 测量文本宽度
    const textWidth = context.measureText(content).width;

    // 限制最大宽度
    return Math.min(textWidth, maxWidth || Infinity);
  },
  openPushNotice() {
    console.log('Empty Func openPushNotice');
  },
  openURL(options, callback?) {
    const url = typeof options?.url === 'string' ? options.url.trim() : '';
    let result;

    if (!url) {
      result = { success: false, message: 'openURL requires a non-empty url' };
      callback?.(result);
      return result;
    }

    try {
      const safeUrl = getSafeWebUrl(url);
      const openedWindow = typeof window.open === 'function'
        ? window.open(safeUrl, '_blank')
        : null;

      if (openedWindow) {
        try {
          openedWindow.opener = null;
        } catch (error) {
          // Cross-origin windows may reject access to opener after opening successfully.
        }
      } else {
        const targetLocation = window.top?.location || window.location;
        if (typeof targetLocation?.assign === 'function') {
          targetLocation.assign(safeUrl);
        } else if (targetLocation) {
          targetLocation.href = safeUrl;
        } else {
          throw new Error('Browser navigation is unavailable');
        }
      }

      result = { success: true, message: '' };
    } catch (error) {
      result = {
        success: false,
        message: error instanceof Error ? error.message : String(error || 'Failed to open URL'),
      };
    }

    callback?.(result);
    return result;
  },
  callPhone({ content }) {
    console.log('callPhone');
    if (!content) return;

    const phoneUrl = `tel:${content}`;
    let anchor: HTMLAnchorElement | null = null;
    try {
      // 通过用户手势点击临时链接唤起系统拨号器，避免直接修改顶层 location
      // 导致订单详情 SPA 状态和 history 被浏览器当成一次页面导航处理。
      // 使用当前 frame 的 document，并由 target=_top 声明顶层打开意图，避免跨域读取 top.document。
      anchor = document.createElement('a');
      anchor.href = phoneUrl;
      anchor.target = '_top';
      anchor.rel = 'noreferrer';
      anchor.style.display = 'none';
      (document.body || document.documentElement).appendChild(anchor);
      anchor.click();
    } catch (error) {
      // 当前 document 不可用时保留拨号兜底；属性访问或导航失败均不向业务调用链抛异常。
      try {
        const targetLocation = window.location;
        if (typeof targetLocation?.assign === 'function') {
          targetLocation.assign(phoneUrl);
        } else {
          console.warn('callPhone navigation is unavailable', error);
        }
      } catch (navigationError) {
        console.warn('callPhone navigation failed', error, navigationError);
      }
    } finally {
      try {
        if (typeof anchor?.remove === 'function') {
          anchor.remove();
        } else {
          anchor?.parentNode?.removeChild(anchor);
        }
      } catch (cleanupError) {
        console.warn('callPhone anchor cleanup failed', cleanupError);
      }
    }
  },
  copyText(options) {
    // 复制content，并toast提示successDescription内容
    const {
      content,
      successDescription,
    } = options;

    if (!content) {
      return;
    }

    try {
      const success = copyTextToClipboard(content);
      if (success) {
        successDescription && Toast.show(successDescription);
      } else {
        console.log('复制失败');
      }
    } catch (error) {
      console.error('复制失败:', error);
    }
  },
};

export default module;
